import { render, staticRenderFns } from "./roomBook.vue?vue&type=template&id=79205b6c&scoped=true&"
import script from "./roomBook.vue?vue&type=script&lang=js&"
export * from "./roomBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79205b6c",
  null
  
)

export default component.exports